export const MuiPagination = (palette) => ({
  styleOverrides: {
    root: {
      border: `1px solid ${palette.neutral[300]}`,
      borderRadius: '4px',
      'li:first-child button': {
        borderRight: `1px solid ${palette.neutral[300]}`,
      },
    },
  },
});

export const MuiPaginationItem = (palette) => ({
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: {
      margin: 0,
      padding: '6px 12px',
      color: palette.text.secondary,
      borderRight: `1px solid ${palette.neutral[300]}`,
      borderRadius: 0,
      '&.MuiPaginationItem-previousNext': {
        borderRight: 0,
      },
      '&.Mui-selected': {
        color: palette.primary.main,
        backgroundColor: palette.primary[100],
      },
    },
  },
});
